export const UserType = {
  client: "client",
  coach: "coach",
  admin: "admin",
};

export const ROUTES = {
  HOME: "/",
  SIGN_IN: "/sign-in",
  DASHBOARD: "/dashboard",
  TRAINING_PLAN: "/training-plan",
  WORKOUT_TOOLS: "/workout-tools",
  PRINTABLE_PLAN: "/training-plan/print",
  EXERCISE_DETAILS: "/exercise",
};
